const mediaItems = [
  {
    title: '台北娜娜 · 最新视频独家解读',
    duration: '12:35',
    views: '8.6万',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20video%20thumbnail%20style%20scene%20with%20warm%20orange%20and%20red%20lighting%2C%20cinematic%20frame%20with%20dramatic%20mood%2C%20female%20silhouette%2C%20no%20text%2C%20modern%20video%20aesthetic&width=640&height=360&seq=media-nana&orientation=landscape',
  },
  {
    title: '莫里秀 · 深度揭秘专题视频',
    duration: '18:22',
    views: '6.3万',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20investigative%20video%20thumbnail%20with%20warm%20golden%20lighting%2C%20dramatic%20shadow%2C%20male%20silhouette%2C%20no%20text%2C%20documentary%20style%20aesthetic&width=640&height=360&seq=media-moli&orientation=landscape',
  },
  {
    title: '玩偶姐姐 · 精彩片段集锦',
    duration: '09:47',
    views: '5.1万',
    img: 'https://readdy.ai/api/search-image?query=A%20stylish%20dark%20video%20thumbnail%20with%20warm%20pink%20and%20amber%20lighting%2C%20elegant%20composition%2C%20no%20text%2C%20fashion%20editorial%20video%20aesthetic&width=640&height=360&seq=media-wanou&orientation=landscape',
  },
  {
    title: '暗网吃瓜 · 人物专题纪录片',
    duration: '22:10',
    views: '9.8万',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20documentary%20style%20video%20thumbnail%20with%20warm%20orange%20lighting%2C%20multiple%20floating%20elements%2C%20no%20text%2C%20cinematic%20portrait%20aesthetic&width=640&height=360&seq=media-doc&orientation=landscape',
  },
  {
    title: '51吃瓜 · 本周爆料盘点',
    duration: '15:03',
    views: '7.2万',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20news%20style%20video%20thumbnail%20with%20warm%20amber%20lighting%2C%20floating%20headline%20elements%2C%20no%20text%2C%20broadcast%20aesthetic&width=640&height=360&seq=media-weekly&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          独家视频爆料
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          精选视频内容，精彩不容错过
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl border border-background-200/60 bg-background-100/50 overflow-hidden transition-all duration-300 hover:border-primary-500/30 hover:translate-y-[-2px] cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-background-950/30 group-hover:bg-background-950/20 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-200">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}